import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Button,
  TextField,
  Box,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Logo from "../../../Assets/images/logo1024.png";
import "./Login.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import functions, { setToken } from "../../../utils/Api";
import Toaster from "../../../components/Toaster/Toaster";
import { useDispatch } from "react-redux";
import { setToasterStatusMsg } from "../../../Redux/reportSlice";

const Login = ({ setIsAuthenticated, setIsAdmin }) => {
  const navigate = useNavigate();
  const dispatcher = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  // Validation schema for email and password
  const validationSchema = Yup.object({
    username: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  // Function to handle form submission
  const handleSubmit = (values, { setSubmitting }) => {
    setErrorMessage(null);
    functions
      .post("/cms/login", values)
      .then((res) => {
        if (res) {
          localStorage.setItem("accessToken", JSON.stringify(res?.data));
          setIsAuthenticated(res.data);
          setToken(res?.data?.accessToken);
          navigate("/cms/dashboard");
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatcher(setToasterStatusMsg({ msg: err, severity: "error" }));
        // setErrorMessage(err);
      })
      .finally(() => setSubmitting(false));
    // setIsAuthenticated(true);
    // navigate("/cms/dashboard");
    // setSubmitting(true);
    // setSubmitting(false);

    // setIsAdmin(true);

    // navigate("/cms/dashboard");
  };

  return (
    <Box className="Login-main">
      <img src={Logo} alt="Logo" style={{ width: "100px" }} />
      <Card sx={{ width: 500, mx: "auto", mt: 4 }}>
        <Formik
          initialValues={{ username: "", password: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isSubmitting,
          }) => (
            <Form>
              {/* Step 1: Email Step */}
              {/* {step === 1 && ( */}
              <>
                <CardHeader title="Login" />
                <CardContent>
                  <Box mb={2}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Email"
                      name="username"
                      type="email"
                      size="small"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.username} // Keep the email entered
                      error={touched.username && Boolean(errors.username)}
                      helperText={touched.username && errors.username}
                      InputLabelProps={{
                        shrink: true, // Forces the label to stay at the top
                      }}
                    />
                    {/* <----------------- --------> */}
                    <Box mt={3} mb={2}>
                      <Field
                        as={TextField}
                        fullWidth
                        label="Password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        size="small"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                        error={touched.password && Boolean(errors.password)}
                        helperText={touched.password && errors.password}
                        InputLabelProps={{
                          shrink: true, // Forces the label to stay at the top
                        }}
                        InputProps={{
                          // input: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                          // },
                        }}
                      />
                    </Box>
                    {/* <--------------> */}
                  </Box>
                  <Box className="adminlogin-Btn">
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      sx={{ mt: 2, textTransform: "capitalize" }}
                      loading={isSubmitting}
                    >
                      Login
                    </LoadingButton>
                    {/* <Button
                        variant="contained"
                        color="primary"
                        disabled={!values.email} // Disable if email is empty
                        sx={{ mt: 2 }}
                        onClick={() => setStep(2)}
                      >
                        Next
                      </Button> */}
                  </Box>
                </CardContent>
              </>
              {/* )} */}

              {/* Step 2: Password Step */}
            </Form>
          )}
        </Formik>
      </Card>
      {errorMessage && (
        <Toaster
          errMessage={errorMessage || "something went wrong!"}
          severity="error"
        />
      )}
    </Box>
  );
};

export default Login;

// {step === 2 && (
//   <>
//     <CardHeader title="Hello, Guru" />
//     <p className="step-two-header2">
//       To continue, first verify it's you
//     </p>
//     <CardContent>
//       <Box mb={2} className="valid-email">
//         {/* Show the email entered in step 1 */}
//         <p>
//           {values.email} <CheckCircleIcon color="success" />
//         </p>
//       </Box>
//       <Box mb={2}>
//         <Field
//           as={TextField}
//           fullWidth
//           label="Password"
//           name="password"
//           type={showPassword ? "text" : "password"}
//           size="small"
//           onChange={handleChange}
//           onBlur={handleBlur}
//           value={values.password}
//           error={touched.password && Boolean(errors.password)}
//           helperText={touched.password && errors.password}
//           slotProps={{
//             input: {
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     aria-label="toggle password visibility"
//                     onClick={handleClickShowPassword}
//                   >
//                     {showPassword ? (
//                       <Visibility />
//                     ) : (
//                       <VisibilityOff />
//                     )}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             },
//           }}
//         />
//       </Box>
//       <Box className="adminlogin-Btn">
//         <LoadingButton
//           type="submit"
//           variant="contained"
//           sx={{ mt: 2 }}
//           loading={isSubmitting}
//         >
//           Login
//         </LoadingButton>
//       </Box>
//     </CardContent>
//   </>
// )}
